export default {
    Errors: {
        serverError: "There was an unexpected error, please try again"
    },
    App: {
        unauthorized: "Error: Unauthorized"
    },
    HomeView: {
        title: "Universal Header and Footer (UHF)",
        headerAltText: "Universal Header and Footer image showing sample header",
        footerAltText: "Universal Header and Footer image showing sample footer",
        uhfexplanation: "UHF includes many parts, both global and site-specific. Generally, global parts of the UHF are the same across all Microsoft sites. However, sites whose primary audience is either businesses or developers may include a different navigation.",
        howUhfWorks: "How UHF Works",
        howUhfWorksTextOne: "UHF provides the markup and statics for a site's header and footer through a web service. Partner sites integrate the service by calling the service with parameters that specify the partner's configuration. Then they render the response on their page.",
        howUhfWorksTextTwo: "Configuration is done in a content management system (CMS) called Compass, which is separate from UHF. Compass contains a set of documents linked together that contain all the information needed to render UHF for a site. Compass also enables the site to localize the content and configuration for each market.",
        linkBoxOne: "UHF Partner Onboarding",
        linkBoxOneText: "Partner sites that leverage UHF must onboard by providing relevant information about their site and their team. Once the onboarding team has these details, they will provide the partner with an ID with which they can configure their UHF.",
        linkBoxOneLinkText: "Start the Onboarding Process",
        linkBoxOneImageAltText: "Visual representation of partner onboarding",
        linkBoxTwo: "Frequently Asked Questions",
        linkBoxTwoText: "View our Partner FAQ to understand more about each feature of UHF. The FAQ also includes specific guidlines and instructions on how to set up your UHF.",
        linkBoxTwoLinkText: "Go to our Partner FAQ",
        linkBoxTwoImageAltText: "Visual representation of FAQ",
        linkBoxThree: "UHF Support",
        linkBoxThreeText: "UHF Support is available to answer any questions or assist with problems along the way. Depending on the problem, the resolution time may vary.  The more details and information the quicker we can resolve the problem.",
        linkBoxThreeLinkText: "Email UHF Support",
        linkBoxThreeImageAltText: "Visual representation of support",
        linkBoxFour: "Test Your UHF",
        linkBoxFourText: "View your UHF content in our test page so you can compare it to your site and see if there's anything different. This is a great way to determine if an issue is caused by something in UHF or in your site's code.",
        linkBoxFourLinkText: "Test Your UHF",
        linkBoxFourImageAltText: "Visual representation of testing"
    },
    TestView: {
        TestConfigurator: {
            environment: "Environment",
            footerId: "Footer ID",
            headerId: "Header ID",
            serviceLink: "UHF Service URL",
            locale: "Locale",
            options: "Options",
            partnerId: "Partner ID",
            title: "UHF Test Page",
            description: 'A page with your UHF shows in the frame below. Click "Open in new window" to see the test in a new window.',
            openInNewWindow: "Open in new window"
        }
    },
    AdminView: {
        Unauthorized: {
            title: "Oh dear...",
            description: "Looks like you're not allowed in here"
        }
    }
};
